<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return {
      activeTab: ""
    };
  },
  computed: {
  	isViewportSmall() {
  		return globalState.viewport.md | globalState.viewport.sm || globalState.viewport.xs;
  	}
  },
  methods: { 
    getTarget: Fandom.getTarget,
  	itemClasses(item) {
  		let classes = [];

      // When url is a ContentLink extra field type the content name can be used as matching 
      // name when mathing name is missing. 
      if (item.url.content && !item.matching_name) {
        item.matching_name = item.url.content;
      }
      
      const re = new RegExp(`^(${item.matching_name})$`);
      if (re.test(globalState.pageModel.main_content_name)) {
      	classes.push("active");
        this.activeTab = item.url.title;
      }
      return classes;
    },
  	toggleSidebar() {
  		$("#sidebar").collapse("toggle");
      $(this.$el).find('.navbar-toggler').toggleClass('collapsed');
  	},
  	getSubItemUrl(item, subitem) {
      const anchorUrl = subitem.url.url.split("#")[1];
      if (anchorUrl) {
        if (item.url.title != this.activeTab) {
    		  return `${item.url.url}#${anchorUrl}`;
        } else {
          return `#${anchorUrl}`;
        }
      } else {
        return `https://${subitem.url.url.split("/it/")[1]}`;
      }
  	},
    isItemVisible(item) {
      // hide item if it is active and sidebar is collapsed (in this case item title appears as navbar-brand)
      // or url is $empty (that means that there is not a suitable item for actual lang version) 
      return !(this.isViewportSmall && item.url.title == this.activeTab) && item.url.url.indexOf('$empty') == -1;
    }
  }
};
</script>

<template>
	<nav
    v-easyadmin="easyadminId"
    :class="contentType"
    class="navbar navbar-light border-md-0 border bg-white p-0 mt-4 mb-md-4"
    id="sidebar-nav"
    sidebar-component
  >
		<a v-if="isViewportSmall" class="navbar-brand mx-3 overflow-hidden text-uppercase" href="#" @click.stop="toggleSidebar">{{ activeTab || ft('globals.select_item') }}</a>
		<button v-if="isViewportSmall" class="navbar-toggler collapsed mx-3 px-0" type="button" @click="toggleSidebar">
	    <i class="fal fa-chevron-up"></i>
	  </button>
	  <div :class="{'collapse navbar-collapse': isViewportSmall}" id="sidebar">
      <div class="py-2 px-3 border-top border-md-0">
  		  <ul class="navbar-nav">
  		    <li
  		    	v-for="(item,index) in content.sidebar"
            v-if="isItemVisible(item)"
  		    	:key="`sidebar-item-${index}`" 
  		    	class="nav-item" :class="itemClasses(item)">
  		      <a class="nav-link text-uppercase" :href="item.sub_items ? `#collapse-item-${index}` : item.url.url" :data-toggle="item.sub_items ? 'collapse' : ''">
  		      	{{item.url.title}}
  		      </a>
  		      <ul v-if="!isViewportSmall && item.sub_items" class="navbar-nav secondary collapse" :id="`collapse-item-${index}`">
  				    <li 	
  				    	v-for="(subitem, subindex) in item.sub_items"
  				    	:key="`item-${index}-subitem-${subindex}`"
  				    	class="nav-item">
  				      <a class="nav-link text-uppercase" :href="getSubItemUrl(item, subitem)" :target="getTarget(subitem.url)">{{ subitem.url.title}}</a>
  				    </li>
  				  </ul>
  		    </li>
  		  </ul>
      </div>
		</div>
	</nav>
</template>

<style lang="scss">
[sidebar-component] {

  background-color: $white;

  .navbar-brand {
    font-size: 1rem;
    font-weight: 600;
    max-width: 70%;
  }

  .overflow-hidden {
    text-overflow: ellipsis;
  }

	.triangle {
    background-color: $white;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 100%;
    transition: all .25s;
    border: 1px solid $gray-400;
    outline: 0px transparent;

    .fa-caret-down {
      color: $gray-700;
    }

    &:disabled {
      border-color: $gray-300;
      cursor: not-allowed;

      .fa-caret-down {
        color: $gray-300;
      }
    }

    &:hover:not(:disabled) {
      background-color: $gray-400;
      .fa-caret-down {
        color: $white;
      }
    }

    &:not(.collapsed) {
      transform: rotate(180deg);
      background-color: $dark;
      border-color: transparent;

      .fa-caret-down {
        color: $white;
      }
    }
  }

  .navbar-toggler {
    font-size: .875rem;
    transition: transform .25s;
    height: 4rem;
    border: none;

    &:focus {
      outline: 0px;
    }

    &.collapsed {
      transform: rotate(180deg);
    }
  }

  .secondary > .nav-item {
    font-size: .875rem;
    margin-left: 2rem;
  }

  @include media-breakpoint-up(md) {
    .border-md-0, &.border-md-0 {
      border-width: 0px !important;
    }
  }


}
</style>